@if (brandService.brand?.brandCardURL && imgSrc) {
  <div class="brand-card">
    <a [href]="brandService.brand?.brandCardURL" target="_blank">
      <img [alt]="'brand card'" [src]="imgSrc" />
    </a>
  </div>
}
